export type AllowedBrowserLanguage = 'en' | 'it';
export const ALLOWED_BROWSER_LANGUAGES = ['en', 'it'];
